import { BreakpointObserver } from '@angular/cdk/layout';
import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

export const SCREEN_BREAKPOINTS = {
  handset: '(max-width: 767px)',
  tablet: '(max-width: 1023px)',
  desktop: '(min-width: 1024px)',
} as const;

export type ScreenBreakpoint = keyof typeof SCREEN_BREAKPOINTS;

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  private readonly breakpointObserver = inject(BreakpointObserver);

  private readonly breakpointState = toSignal(
    this.breakpointObserver
      .observe(Object.values(SCREEN_BREAKPOINTS))
      .pipe(map((state) => state.breakpoints)),
    {
      initialValue: this.breakpointObserver.isMatched(Object.values(SCREEN_BREAKPOINTS))
        ? Object.fromEntries(
            Object.values(SCREEN_BREAKPOINTS).map((query) => [
              query,
              this.breakpointObserver.isMatched(query),
            ]),
          )
        : {},
    },
  );

  readonly isHandset = computed(() => this.matches('handset'));
  readonly isTablet = computed(() => this.matches('tablet'));
  readonly isDesktop = computed(() => this.matches('desktop'));

  matches(breakpoint: ScreenBreakpoint): boolean {
    return this.breakpointState()[SCREEN_BREAKPOINTS[breakpoint]] ?? false;
  }
}
